import mapboxgl, { Map, PointLike } from "mapbox-gl";
import { PublicPriceOnMap } from "../pages/my_prices/map/MapMillPrice";
import { getBubbleCompareGreenSVG, getBubbleCompareRedSVG, getBubbleMyMillSVG } from "./svgPlainText";

// function overlayImagePrice(map: Map): Promise<string[]> {

//     const svg0 = getBubbleSVG("#000");
//     var image0 = new Image();
//     image0.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg0);
//     const bubble = new Promise<string>((resolver) => {
//         image0.onload = function () {
//             map.addImage('bubble', image0, { pixelRatio: 1 })
//             resolver(image0.src)
//         }
//     })

//     const svg = getBubbleMyMillSVG();
//     var image1 = new window.Image();
//     image1.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
//     const bubbleMyMill: Promise<string> = new Promise((resolver) => {
//         image1.onload = function () {
//             map.addImage('bubble-my-mill', image1, { pixelRatio: 3 })
//             resolver(image1.src)
//         }
//     })

//     const svg2 = getBubbleSVG("#f00");
//     var image2 = new Image();
//     image2.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg2);
//     const bubbleLower = new Promise<string>((resolver) => {
//         image2.onload = function () {
//             map.addImage('bubble-alert', image2, { pixelRatio: 1 })
//             resolver(image2.src)
//         }
//     })
//     const svg3 = getBubbleSVG("#82ff78");
//     var image3 = new Image();
//     image3.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg3);
//     const bubbleHigher = new Promise<string>((resolver) => {
//         image3.onload = function () {
//             map.addImage('bubble-valid', image3, { pixelRatio: 1 })
//             resolver(image3.src)
//         }
//     })

//     const svg4 = getBubbleMyMillSVG();
//     var image4 = new Image();
//     image4.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg4);
//     const bubbleSelected = new Promise<string>((resolver) => {
//         image4.onload = function () {
//             map.addImage('bubble-my-mill-selected', image4, { pixelRatio: 2.5 })
//             resolver(image4.src)
//         }
//     })

//     return Promise.all([bubble, bubbleLower, bubbleHigher, bubbleSelected, bubbleMyMill])
// }

export function UpdatePriceMap(map: Map, prices: any, isMyMill: (id: number) => boolean, priceSelected?: PublicPriceOnMap,
    onClick?: (featureId: any, geometry: any) => void,
    onHover?: (featureId: any, geometry: any) => void,
    onLeave?: () => void) {
    clearAllMarkers();
    setPriceSource(map, prices, isMyMill, priceSelected, onClick, onHover, onLeave);
}

// Function to clear all markers
function clearAllMarkers() {
    currentMarkers.forEach(marker => {
        marker.remove();
    });
    currentMarkers = [];
}

function isOtherPriceHigher(myPrice?: PublicPriceOnMap, otherPrice?: any): boolean {
    return (myPrice?.price_per_unit * (1 - ((myPrice?.standard_grading_ratio ?? 0) / 100))) < (otherPrice?.properties?.price_per_unit * (1 - ((otherPrice?.properties?.standard_grading_ratio ?? 0) / 100)))
}

let currentMarkers: mapboxgl.Marker[] = [];

function setPriceSource(map: Map, json: any, isMyMill: (id: number) => boolean, priceSelected?: PublicPriceOnMap,
    onClick?: (featureId: any, geometry: any) => void,
    onHover?: (featureId: any, geometry: any) => void,
    onLeave?: () => void
) {
    json?.features?.forEach((price: any, i: number) => {
        const myMill = isMyMill(price.properties.organisation_id) ?? false
        const isPriceSelected = (priceSelected?.id === price?.properties?.id)
        const isHigher = isOtherPriceHigher(priceSelected, price)

        const el = document.createElement('div');

        el.addEventListener('click', () => {
            myMill && onClick(price.properties, price.geometry);
        });

        el.addEventListener('mouseenter', () => {
            el.style.cursor = myMill ? 'pointer' : "grab";
            if (onHover && price) {
                onHover(price, price.geometry);
            }
            // You can add hover effects here
        });

        el.addEventListener('mouseleave', () => {
            el.style.cursor = 'default';
            map.getCanvas().style.cursor = '';
            if (onLeave) onLeave();
            // Reset hover effects
        });

        el.className = 'custom-marker';
        var offset: PointLike = [0, 0]
        if (myMill) {
            if (isPriceSelected) {
                offset = [-12, 6]
                const svgBackground = getBubbleMyMillSVG();
                el.innerHTML = `
    <div class="bubble" style="background-image: url('data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgBackground)}'); background-repeat: no-repeat; background-size: contain; width: 100px; height: 60px; position: relative;">
      <div class="price-bubble-my-mill-selected">${(price.properties.price_per_unit ? price.properties.price_per_unit : "-")}</div>
      <div class="price-bubble-potongan-selected">${(price.properties.standard_grading_ratio ? price.properties.standard_grading_ratio + "%" : `<span style="color:red;">-</span>`)}</div>
    </div>
  `;
            } else {
                offset = [-12, 0]
                const svgBackground = getBubbleMyMillSVG();
                el.innerHTML = `
    <div class="bubble" style="background-image: url('data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgBackground)}'); background-repeat: no-repeat; background-size: contain; width: 83px; height: 45px; position: relative;">
      <div class="price-bubble-my-mill">${(price.properties.price_per_unit ? price.properties.price_per_unit : "-")}</div>
      <div class="price-bubble-my-mill-potongan">${(price.properties.standard_grading_ratio ? price.properties.standard_grading_ratio + "%" : `<span style="color:red;">-</span>`)}</div>
    </div>
  `;
            }
        } else {
            const color = !priceSelected ? "#000" : isHigher ? "#f00" : "#6dd100"
            const arrowColor = !priceSelected ? "#fff" : isHigher ? "#f00" : "#6dd100"
            const svgBackground = isHigher ? getBubbleCompareRedSVG(color, arrowColor) : getBubbleCompareGreenSVG(color, arrowColor)
            el.innerHTML = `
            <div class="bubble" style="background-image: url('data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgBackground)}'); background-repeat: no-repeat; background-size: contain; width: 83px; height: 45px; position: relative;">
                <div class="price-bubble-my-mill">${(price.properties.price_per_unit ? price.properties.price_per_unit : "-")}</div>
                <div class="price-bubble-potongan">${(price.properties.standard_grading_ratio ? price.properties.standard_grading_ratio + "%" : `<span style="color:red;">-</span>`)}</div>
            </div>
  `;
        }

        const marker = new mapboxgl.Marker(el, { anchor: "bottom", offset: offset })
            .setLngLat(price.geometry.coordinates)
            .addTo(map);

        currentMarkers.push(marker)
    })
}

export function addMapListenerOnPrice(
    map: Map,
    onCLick?: (featureId: any, geometry: any) => void,
    onHover?: (featureId: any, geometry: any) => void,
    onLeave?: () => void
) {
    map.on('click', ['prices'], (ev) => {
        onCLick(ev.features?.at(0)?.properties, ev.features?.at(0)?.geometry)
    })
    // Change cursor and call onHover when hovering a price
    map.on('mousemove', 'prices', (e) => {
        map.getCanvas().style.cursor = 'pointer';
        if (onHover && e.features && e.features.length > 0) {
            onHover(e.features[0], e.features[0].geometry);
        }
    });
    // Reset cursor and call onLeave when leaving a price
    map.on('mouseleave', 'prices', () => {
        map.getCanvas().style.cursor = '';
        if (onLeave) onLeave();
    });
}